import Auth from "../Auth";
import Subscription from "./Subscription";
import { POVS, TENSES } from "../../../src/shared/constants";
import validateCharactersArray from "../../../src/shared/utils/validateCharactersArray";

function normalizeTenseInput(tense) {
  if (tense && typeof tense === "object") {
    return {
      value: tense.value,
      userChanged: tense.userChanged === true,
    };
  }
  return {
    value: tense,
    userChanged: false,
  };
}

export default class POVTense {
  constructor(pov, tense) {
    // Validate and clean characters array
    const cleanCharacters = validateCharactersArray(pov?.characters || []);

    this.pov = {
      value: pov?.value,
      characters: cleanCharacters,
      userChanged: pov?.userChanged === true,
    };
    this.tense = normalizeTenseInput(tense);
  }

  static fromJSON(json) {
    const { pov, tense } = json;
    return new POVTense(pov, tense);
  }

  /**
   * Updates the POV with validation
   * @param {Object} newPov - The new POV object
   */
  updatePOV(newPov) {
    const cleanCharacters = validateCharactersArray(newPov.characters || []);
    this.pov = {
      ...newPov,
      characters: cleanCharacters,
      userChanged: newPov?.userChanged === true,
    };
  }

  toJSON() {
    return {
      pov: this.pov,
      tense: this.tense,
    };
  }

  static async findById(id) {
    return await Auth.fetchWithIdToken(`/api/povTense/${id}`);
  }

  static async update(userId, povTenseId, povTense) {
    const subscription = await Subscription.fetchFromUserId(userId);
    const { hasAccessToPOVAndTenseBeta } = subscription.getFeatureFlags();
    if (!hasAccessToPOVAndTenseBeta) {
      return;
    }

    return await Auth.fetchWithIdToken(`/api/povTense/${povTenseId}`, {
      method: "PUT",
      povTense,
    });
  }

  static async create(pov, tense, projectId, userId, documentId) {
    const subscription = await Subscription.fetchFromUserId(userId);
    const { hasAccessToPOVAndTenseBeta } = subscription.getFeatureFlags();
    if (!hasAccessToPOVAndTenseBeta) {
      return;
    }

    let povValue = pov;
    if (!povValue) {
      povValue = { value: POVS.THIRD_PERSON_LIMITED, characters: [], userChanged: false };
    }

    let tenseValue = tense;
    if (!tenseValue) {
      tenseValue = { value: TENSES.PAST, userChanged: false };
    }

    const povTense = new POVTense(povValue, tenseValue);

    return await Auth.fetchWithIdToken(`/api/povTense`, {
      method: "POST",
      ...povTense,
      projectId,
      userId,
      documentId,
    });
  }

  static isValidPovValue(povValue) {
    return Object.values(POVS).includes(povValue);
  }

  static isValidTenseValue(tenseValue) {
    return Object.values(TENSES).includes(tenseValue);
  }
}
